module.exports = __webpack_public_path__ + "static/media/sputnik.d2c48b72.m4a";